import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { Locale } from '../../core/constants';

type DoodleProps = {
  className?: string;
};

const Doodle = ({ className }: DoodleProps) => {
  const { t } = useTranslation(['common', 'component']);
  const { locale } = useRouter();

  const getTitle = () => {
    switch (locale) {
      case Locale.JAPANESE:
        return (
          <>
            {t('component:doodle.title.welcome')}
            <span className="text-orange-700">{t('common:tabist.name')}</span>{' '}
            {t('component:doodle.title.to')}
          </>
        );
      default:
        return (
          <>
            {`${t('component:doodle.title.welcome')} ${t('component:doodle.title.to')} `}
            <span className="text-orange-700">{t('common:tabist.name')}</span>
          </>
        );
    }
  };

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <div className="pb-2 text-title2 font-bold">{getTitle()}</div>
      <div className="pb-10 text-regular">{t('component:doodle.description')}</div>
      <Image src="/travel-doodle.svg" width={359} height={334} alt="travel-doodle" />
    </div>
  );
};

export default Doodle;
